<template>
    <div class="login-container">
        <video autoplay muted loop playsinline class="bg-video">
            <source src="@/assets/background.mp4" type="video/mp4" />
        </video>

        <div class="login-form-wrapper">
            <v-card class="login-card bounce-in-top" elevation="10">
                <fibryo-logo v-if="isWhitelabel" class="fibryo-logo-lg pt-4 pb-4" :color="theming.cardsAndTablesText" />
                <div v-else class="image-wrapper pt-4 pb-4">
                    <v-img class="logo-image" height="auto" width="300px" :src="require(`@/assets/companies/${this.companyName}.png`)" />
                </div>
                <login-form @setAlert="setAlert" />
            </v-card>
            <alert class="alert" :show-alert="showAlert" :message="message" :type="type" />
        </div>
        <div v-if="!isWhitelabel" class="brand">
            <span>powered by</span>
            <fibryo-logo class="fibryo-logo" :color="theming.cardsAndTablesText" />
        </div>
        <div class="powered-by-wrapper">
            <span class="powered-by">
                developed by
            </span>
            <span class="powered-by-name" @click="onNameClick">
                Karageorgos Dimitris
            </span>
        </div>
    </div>
</template>

<script>
    import LoginForm from '@/forms/LoginForm'
    import Alert from '@/components/Alert'
    import FibryoLogo from '@/components/FibryoLogoSVG'
    const COMPANY_NAME = process.env.VUE_APP_ENV_COMPANY_NAME

    export default {
        components: { LoginForm, Alert, FibryoLogo },
        data() {
            return {
                showAlert: false,
                message: '',
                type: null
            }
        },
        computed: {
            companyName() {
                return COMPANY_NAME
            },
            isWhitelabel() {
                return this.companyName === 'fibryo'
            },
            theming() {
                return this.$store.getters.getTheming || {}
            }
        },
        watch: {
            tab: {
                handler(newval, oldval) {
                    if (newval) {
                        if (this.showAlert !== false) {
                            this.showAlert = false
                        }
                    }
                }
            },
            showAlert: {
                handler(newval, oldval) {
                    if (newval !== oldval) {
                        setTimeout(() => { this.showAlert = false }, 7000)
                    }
                }
            }
        },
        methods: {
            setAlert(message, type) {
                this.showAlert = true
                this.message = message
                this.type = type
            },
            onNameClick() {
                window.open('https://karageorgos-dimitris.com', '_blank').focus()
            }
        }
    }
</script>

<style scoped>
.bounce-in-top{animation:bounce-in-top 1.1s both}
@keyframes bounce-in-top{0%{transform:translateY(-500px);animation-timing-function:ease-in;opacity:0}38%{transform:translateY(0);animation-timing-function:ease-out;opacity:1}55%{transform:translateY(-65px);animation-timing-function:ease-in}72%{transform:translateY(0);animation-timing-function:ease-out}81%{transform:translateY(-28px);animation-timing-function:ease-in}90%{transform:translateY(0);animation-timing-function:ease-out}95%{transform:translateY(-8px);animation-timing-function:ease-in}100%{transform:translateY(0);animation-timing-function:ease-out}}
.login-card {
  background-color: rgb(255, 255, 255, 0.7); /* 60% opacity */
  backdrop-filter: blur(1px);
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
}
.bg-video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 1;
}

.login-form-wrapper,
.brand,
.powered-by-wrapper {
    position: relative;
    z-index: 2;
}

.fibryo-logo-lg {
    width: 200px;
    margin: 0 auto;
}
.fibryo-logo {
    width: 150px;
}
.alert {
    width: 100%;
    height: 14vh;
    margin-bottom: 5vh;
    max-height: 120px;
}
.brand {
    font-style: italic;
    font-weight: 400;
    font-size: 0.8rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
}

.login-form{
    width: 300px;
}
.error-message {
    display: flex;
    justify-content: center;
    color: red;
    font-weight: bold;
}

/* .logo-image {
    margin: 0 auto;
} */
.image-wrapper{
    width: 80%;
    margin: 0 auto;
}

.powered-by-wrapper {
    position: fixed;
    bottom: 0;
    right: 0;
}

.powered-by {
    font-size: 0.7rem;
}

.powered-by-name {
    font-size: 0.9rem;
    cursor: pointer;
    padding-right: 1rem;
}

.powered-by-name:hover {
    color: #01aebe
}

.login-container {
    background: white;
    color: black;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
}

.login-form-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 70%;
    /* padding-top: 25vh; */
}
</style>
<style>
input, .v-select__selection, .v-select__selections {
    color: black !important;
}
.v-text-field .v-input__control {
    color: black !important;
}
.theme--light.v-input textarea {
    color: black !important;
}
</style>
